import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoInformation = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Information</title>
    <path
      d="M4.276 16.997C4.276 9.973 9.97 4.28 16.994 4.28s12.718 5.694 12.718 12.718-5.694 12.718-12.718 12.718S4.276 24.021 4.276 16.997Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path stroke="currentColor" strokeWidth={2.5} strokeLinejoin="round" d="M16.995 10.998h.01v.01h-.01z" />
    <path
      d="M16.993 24.387v-8.783"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoInformation;
